/* global $ */
var Proj = (function(proj){
    'use strict';

    proj.slickSlider = function(options){
        var opt = $.extend({}, options)

        $(opt.selector).slick({
            slidesToShow: opt.slidesToShow,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: opt.dots,
            arrows: opt.arrows,
            responsive: [
                {
                    breakpoint: 1240,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 780,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        })
    };

    proj.relatedSlider = function() {
        $(".js-related-slider").each(function() {
            $(".js-related-slider-item", this).scroller({
                prev: $(".js-related-slider-prev", this),
                next: $(".js-related-slider-next", this)
            });
        });
    };

    return proj;
})(Proj || {});



